import type { ApiMessage } from '../../api/types';
import { isModFeatureEnabled } from '../../util/modFeatures';

import { getArchiveEntry, getArchivedDeletedForChat } from './store';

export function enrichMessageFromArchive(message: ApiMessage): ApiMessage {
  const entry = getArchiveEntry(message.chatId, message.id);
  if (!entry) {
    return message;
  }

  let result = message;

  if (isModFeatureEnabled('antiEditHistory') && entry.editHistory?.length) {
    const mergedHistory = [
      ...(message.editHistory || []),
      ...entry.editHistory.filter(
        (h) => !(message.editHistory || []).some(
          (m) => m.editDate === h.editDate,
        ),
      ),
    ];
    if (mergedHistory.length) {
      result = { ...result, editHistory: mergedHistory };
    }
  }

  if (isModFeatureEnabled('antiDelete') && entry.isDeleted) {
    result = {
      ...result,
      isDeleted: true,
      isDeleting: undefined,
      content: entry.snapshot.content,
      text: entry.snapshot.text ?? result.text,
    };
  }

  return result;
}

export function enrichMessagesByIdFromArchive(
  chatId: string,
  byId: Record<number, ApiMessage>,
): Record<number, ApiMessage> {
  const enriched: Record<number, ApiMessage> = {};
  Object.keys(byId).forEach((idStr) => {
    const id = Number(idStr);
    const message = byId[id];
    if (!message) return;
    enriched[id] = enrichMessageFromArchive(message);
  });
  return enriched;
}

export function injectArchivedDeletedMessages(
  chatId: string,
  byId: Record<number, ApiMessage>,
): Record<number, ApiMessage> {
  if (!isModFeatureEnabled('antiDelete')) {
    return byId;
  }

  const result = { ...byId };
  getArchivedDeletedForChat(chatId).forEach((entry) => {
    if (!result[entry.messageId]) {
      result[entry.messageId] = enrichMessageFromArchive({
        ...entry.snapshot,
        isDeleted: true,
        isDeleting: undefined,
      });
    }
  });

  return result;
}
